import { render, staticRenderFns } from "./NavContractedSection.vue?vue&type=template&id=05bcca12"
import script from "./NavContractedSection.vue?vue&type=script&lang=js"
export * from "./NavContractedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationNavContractedItem: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/navigation/NavContractedItem.vue').default})
